import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as Api from 'api';

class DeleteAllClients extends React.Component {
  state = {
    show : false,
    confirming: false,
    deleting: false,
    done: false,
  }
  render() {
    return (
      <div>
        <div onClick={e => this.setState({show: true})} className="btn btn-block btn-danger">
          <i className="fa fa-trash"></i> Delete All Clients
        </div>
        <Modal show={this.state.show} onHide={e => this.setState({confirming:false, show: false})}>
          <Modal.Body>
            {this.state.deleting? (
              <div className="alert alert-info text-center"><i className="fa fa-spin fa-spinner"></i> Deleting All Clients</div>
            ): <div className="row">
              <div className="col-xs-12">
                <h3>Are you sure?</h3>
                <p>This is an irreversible action! Doing this will delete any clients you have stored in the database.</p>
                <p></p>
                <p></p>
                {this.state.confirming ? <p className="animated fadeInDown alert alert-info">By clicking this button, I acknowledge that I am deleting all the clients in my account.</p>: ''}
              </div>
              <hr />
              <div className="col-xs-12 col-sm-6">
                {!this.state.confirming?  <div onClick={e => this.setState({confirming:true})} className="btn btn-warning"><i className="fa fa-trash"></i>Delete</div> : <div onClick={e => {
                  this.setState({deleting: true});
                  Api.deleteAllClients().then(reponse => {
                    this.props.notify({message:"Deleted clients!", title:'Success!'},{type: 'success'});
                    this.setState({done: true, deleting:false, confirming:false, show: false});
                  }).catch(e => {
                    this.props.notify(e);
                    this.setState({deleting: false, confirming: false});
                  });
                }} className="animated fadeInRight btn btn-block btn-danger">Yes, Delete all my clients.</div>}
              </div>
              <div className="col-xs-12 col-sm-6">
                <div onClick={e => this.setState({show: false, confirming: false})} className="btn btn-block btn-default">Cancel</div>
              </div>
            </div>}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default connect(f => ({}), Actions)(DeleteAllClients);



// WEBPACK FOOTER //
// ./src/browser/components/clients/delete-all-clients.js